<template>
  <div id="participantsBaseinfo">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'participantsBaseinfo'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/participants/Baseinfo.vue